<div #danger class="bg-red-300 p-4 w-full text-black rounded shadow-lg mb-4">
  <ng-content></ng-content>
</div>
